import { Sponsor } from "../components/Sponsor";

const sponsorList = [
    {
        name: "St. Stephens Green",
        image: "/images/StStephensLogo.avif",
        website: "https://www.ststephensgreen.com/"
    },
    {
        name: "Purple Fox Electrical",
        image: "/images/HighResPurpleFoxClean.svg",
        website: "https://purplefoxelectrical.com/"
    },
    {
        name: "Oakland United Brewing",
        image: "/images/OaklandUnitedLogo.png",
        website: "https://oaklandunitedbeerworks.com/"
    },
    {
        name: "Zell Associates",
        image: "/images/ZellLogo.jpg",
        website: "https://www.zell.com/"
    },
    // {
    //     name: "Max Gaines United",
    //     image: "",
    //     website: ""
    // },
    {
        name: "Clarity Capital Group",
        image: "/images/ClarityLogo.jpg",
        website: "https://claritycapitalgroup.com/"
    }
];

export const SponsorsPage = () => {
    return (
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around", gap: 30, rowGap: 30 }}>
            {
                sponsorList.map((sponsor) => <Sponsor name={sponsor.name} image={sponsor.image} website={sponsor.website}/>)
            }
        </div>
    );
}